import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {ShaperFlowGraph} from "../../graphs/shaper/shaper_flow_graph";

export class ShaperFlowCountDashlet extends BaseDashlet {
    constructor(slot) {
        super(slot);
    }

    title() {
        return "Flow Count";
    }

    buildContainer() {
        let base = super.buildContainer();
        base.appendChild(this.graphDiv());
        return base;
    }

    fetchGraph() {
        $.get("/api/shaperFlowCount/" + this.node_id, (data) => {
            this.graph.update(data);
        });
    }

    setup() {
        const urlParams = new URLSearchParams(window.location.search);
        let node_id = urlParams.get("shaper_id");
        if (node_id === null) {
            node_id = 0;
        }
        this.node_id = node_id;

        super.setup();
        this.graph = new ShaperFlowGraph(this.graphDivId());
        this.fetchGraph();
        this.registerTimeGraphHandler(this);
    }

    onMessage(msg) {
    }

    onTimeChange() {
        this.fetchGraph();
    }
}
